import React, { Component } from 'react';
import logo from '../assets/mb-logono plus.png';
import logo1MIN from '../assets/Mask Group 26@3x.png';
import logo2MIN from '../assets/mb_login_image_2_min.jpg';
import logo3MIN from '../assets/mb_login_image_3_min.jpg';
import {axiosFinal, _axios} from '../plugins/axios';
import { USER,Roles } from '../constants/insurance/constant';
import auth from '../auth/auth';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { cleverTap } from '../services/provider/common';
import { CLEVER_TAP_EVENTS } from '../constants/provider/constant';
import Button from '@mui/material/Button'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import OtpInput from 'react-otp-input';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { toast } from "react-toast";

class SignUp extends Component {

  constructor(props) {
    super(props);
    this.state = {
       items  : [
        {img: logo1MIN},
        {img: logo2MIN},
        {img: logo3MIN}
      ],
      errors: {
        email: true
      },
      showLoginDisabled: true,
      showMessage:null,
      showForgotDialogBox : false,
      accessToken : props.match.params.token ? props.match.params.token : null,
      id : props.match.params.id ? props.match.params.id : null,
      tokenExpired:false,
      email:props?.params?.match?.userName ?? "",
      otpVerification: false,
      otp:null,
      otpErr:"",//forValidating
      resendOtp:"",
      resendOtpErr:false,
      blockPasswordChange:false,
      tempAccessToken:null,
      passwordChange: false,
      passwordChangeErr:"",
      oldPassErr:"",
      newPassErr:"",
      confNewPassErr:"",
      oldPassValid:false,
      newPassValid:false,
      confNewPassValid:false,
      allowPassChange: false,
      askToRelogin:false,
      //to showHide passwords
      showPassword: false,
      showNewPassword: false,
      showOldPassword: false,
    }
  this.url = window.location.hostname.includes('-stage') || window.location.hostname.includes("localhost") ? "https://providernode-stage.medibuddy.in/" : "https://providercore.medibuddy.in/" ;// URL.providercore_url;
  }

  componentDidMount(){
    if(localStorage.getItem("tokenExpired")){
      toast.error("Session is expired, Login again to continue")
      localStorage.removeItem("tokenExpired");
    }
    if(this.state.accessToken)
      this.login();
    cleverTap(CLEVER_TAP_EVENTS.loginVisited,{srcPage:"Login Page"})
  }
  
  handleForgotPassDialogBox(value){
    if(this.state.email){
      this.setState({
        otpVerification:true,
        showForgotDialogBox:true,
      },()=>this.sendOtp())
    }else{
      toast.warn("Please enter Email for OTP!")
    }
  }

  setStateCredentials(emailValue) {
    this.setState({
      errors: {
        email: emailValue,
      },
      showLoginDisabled: false
    })
  }

  checkCredentials = (event) => {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    if (!pattern.test(event.target.value)) {
      this.setStateCredentials(false);
    } else {
      this.setState({email: event.target.value})
      this.setStateCredentials(true);
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if(!this.state.passwordChange && !this.state.showForgotDialogBox && !this.state.forcePasswordChange )
    this.setState({email:data.get("email")},()=>this.login(data))
    else
      if(this.state.showForgotDialogBox){
        this.forgotPass(data);
      }else{
        if(this.state.forcePasswordChange){
          this.validateOtp(data)
        }
        else{
          this.setNewPassword(data)
        }
      }
  };

  returnRole(roleId){
    switch(roleId){
      case 5432 : return 'dcadmin';
      case 5433 : return 'dcoperations';
      case 9207 : return 'insureradmin';
      case 9211 : return 'insureragent';
      case 9214 : return 'insurerbranch';
      case 9217 : return 'mareport';
      case 9219 : return 'insurercallCentre';
      default : return null;
    }
  }
  
  checkRoleId(users){
    let role = this.returnRole(users.roleId);
    if(role == null && users.rolesFeatures && users.rolesFeatures.roles){
       users.rolesFeatures.roles.forEach(elem =>{
         if(this.returnRole(elem.roleId) != null && role == null){
          role = this.returnRole(elem.roleId);
        }
      })
      return role;
    }else{
      return role;
    }
  }
  checkFormValidity(){
    if((this.state.oldPassValid || this.state.showForgotDialogBox || this.state.forcePasswordChange) && this.state.newPassValid && this.state.confNewPassValid){
      this.setState({allowPassChange:true})
    }
    else{
      this.setState({allowPassChange:false})
    }
  }

  passwordRegex(event, type){
    if(type === "oldPassword"){
      this.setState({oldPassErr:event.target.value.length ?"":"Old Password cant be empty", oldPassValid:event.target.value.length ? true:false},()=>this.checkFormValidity())
      return;
    }
    let regex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$");
    if( regex.test(event.target.value)){
      switch (type) {
        case "confNewPassword":
          this.setState({confNewPassErr:"", confNewPassValid:true},()=>this.checkFormValidity())
          break;
          case "newPassword":
          this.setState({newPassErr:"", newPassValid:true},()=>this.checkFormValidity())
          break;
          
        default:
          this.checkFormValidity()
          break;
      }
    }else
    switch (type) {
      case "confNewPassword":
        this.setState({confNewPassErr:"Password must be at least 8 characters long, contain at least one number and have a mixture of uppercase, lowercase letters and symbols.", confNewPassValid:false},()=>this.checkFormValidity())
        break;
        case "newPassword":
        this.setState({newPassErr:"Password must be at least 8 characters long, contain at least one number and have a mixture of uppercase, lowercase letters and symbols.", newPassValid:false},()=>this.checkFormValidity())
        break;
        
      default:
        this.checkFormValidity()
        break;
    }
  }
  
  sendOtp = () => {
		// setOtpErr(null);
		let config = {
			url: this.url + "provider/sendEmailOTPForDevice",
			method: "post",
			data: {
				// "authUserId": 0,
				// "isAuthenticated": true,
				"applicationId": 10007,
				"userName": this.state.email,
				"emailId": this.state.email,
				"corporateEmailAddress": this.state.email,
			}
		}
		axiosFinal(config)
			.then(res => {
				if (res.data.isSuccess) {
          this.setState({
            otp:null,
            otpErr:null,
            resendOtpErr:false,
            resendOtp:res.data.reasonPhrase ? res.data.reasonPhrase : "Otp sent successfully",
          })
					// setOtp(null)
					// setOtpSendSuccess(true)
					// setOtpResend(res.data.reasonPhrase ? res.data.reasonPhrase : "Otp sent successfully")
				}
				else {
          this.setState({
            otp:null,
            otpErr:null,
            resendOtpErr:true,
            resendOtp:res.data.reasonPhrase ? res.data.reasonPhrase : res?.data?.error ?? "Otp not sent successfully",
          })
					// setOtp(null)
					// setOtpSendSuccess(false)
					// setOtpResend(res && res.data && res.data.errorMessage ? res.data.errorMessage : "Otp not sent!")
				}
			})
			.catch(err => {
        this.setState({
          otp:null,
          otpErr:null,
          resendOtpErr:true,
          resendOtp:err && err.data && err.data.errorMessage ? err.data.errorMessage : err?.data?.error ?? "Otp not sent!",
        })
				// setOtp(null)
				// setOtpSendSuccess(false)
				// setOtpResend(err && err.data && err.data.errorMessage ? err.data.errorMessage : "Otp not sent!")
			})
	}

  validateOtp (data) {
    // const that = this ;
    if(!this.state.otp) {
      this.setState({passwordChangeErr:"Otp is required"}); 
      return
    }
    if(data && data.get("newPassword")!==data.get("confNewPassword")) {
      this.setState({passwordChangeErr:"New Password and Confirmed Passwords does not match"}); 
      return
    }
		let config = {
			url: this.url + "provider/validateEmailOTP",
			method: "post",
			data: {
				"authUserId": 0,
				"isAuthenticated": true,
				"applicationId": 10007,
				"emailId": this.state.email,
				"userName": this.state.email,
				"corporateEmailAddress": this.state.email,
        "accessToken": this.state.tempAccessToken,
        "deviceName": window.deviceId,
				"otp": this.state.otp,
			}
		}

    if(this.state.forcePasswordChange && data ) config.data.newPassword = data.get("newPassword")

		axiosFinal(config)
		.then(res=>{
		  if(res.data.isSuccess || res.data.success){
        if(this.state.blockPasswordChange || this.state.forcePasswordChange){
          this.setState({
            accessToken:res.data.accessToken.access_token
          }, ()=>{
            this.login()
          })
          // this.setState({accessToken:res.accessToken.access_token},this.login());
        }
        else{
          this.setState({
            resendOtp: null,
            passwordChange:true
          })
        }
		  }
		  else{
        this.setState({
          resendOtp:null,
          passwordChange:false,
          otpErr: res && res.data && res.data.errorMessage ?  res.data.errorMessage :( res?.data?.error ?? "Please Provide Valid Otp" )
        })
		  }
		})
		.catch(err=>{
      this.setState({
        resendOtp:null,
        otpErr: err && err.data && err.data.errorMessage ?  err.data.errorMessage: err && err.data &&err.data.error?err.data.error : "Not Able to Validate Otp"
      })
		});
	}

  setNewPassword(data){
    if(data.get("newPassword")!==data.get("confNewPassword")) {this.setState({passwordChangeErr:"New Password and Confirmed Passwords does not match"}); return}
		let config = {
			url: this.url + "provider/changePasswordUserName",
			method: "post",
			data: {

				"authUserId": 0,
				"isAuthenticated": true,
				"applicationId": 10007,
				// "emailId": this.state.email,
				"userName": this.state.email,
				// "corporateEmailAddress": this.state.email,
				"oldPassword" : data.get("oldPassword"),
				"newPassword" : data.get("newPassword"),
			}
		}
		axiosFinal(config)
		.then(res=>{
		  if(res.data.isSuccess){
        this.resetToLogin(()=>toast.success("Password Change Successfull!"))
		  }
		  else{
        this.setState({
          resendOtp:null,
          passwordChangeErr: res && res.data && res.data.errorMessage ?  res.data.errorMessage: res?.data?.error ?? "Unable to Change Password"
        })
		  }
		})
		.catch(err=>{
      this.setState({
        resendOtp:null,
        passwordChangeErr: err && err.data && err.data.errorMessage ?  err.data.errorMessage: err && err.data &&err.data.error?err.data.error : "Unable to Change Password"
      })
		  })
	}

  resetToLogin(callBack){
    this.setState({
      showMessage:null,
      otpVerification: false,
      otp:null,
      otpErr:"",//forValidating
      resendOtp:"",
      resendOtpErr:false,
      blockPasswordChange:false,
      tempAccessToken:null,
      passwordChange: false,
      passwordChangeErr:"",
      oldPassErr:"",
      newPassErr:"",
      confNewPassErr:"",
      oldPassValid:false,
      newPassValid:false,
      confNewPassValid:false,
      allowPassChange: false,
      askToRelogin:false,
      //to showHide passwords
      showPassword: false,
      showNewPassword: false,
      showOldPassword: false,
      forcePasswordChange:false,
      showForgotDialogBox:false,
    },callBack())
  }
  
  login(data){
    cleverTap(CLEVER_TAP_EVENTS.loginAttempted, {
      srcPage:"/login"
    })
    const that = this;
    let route = that.url + 'provider/v2/Authenticate'
    let roleName = null;
    var obj 
    if(data)
      obj = {
        userName: data.get('email'),
        applicationId: 10007,
        password: data.get('password'),
        deviceName: window.deviceId,
      };
      else
      if(this.state.accessToken){
        obj = {
          accessToken: this.state.accessToken,
          fromOldPortal: true,
          providerId: this.state.id,
          deviceName: window.deviceId,
          userName:this.state.email
        }
      }
      let config = {
        url:route,
        data:obj,
        method:"post",
        headers:{
          "deviceName": window.deviceId
        }
      }
      axiosFinal(config)
    .then(function (response) {
      if(response.data.isAuthenticated){
        toast.success("Logged in Successfully.")
        that.setState({
          showMessage : null
        },that.loginSetData(response, that))
      }else if(!response.data.isAuthenticated){
        cleverTap(CLEVER_TAP_EVENTS.loginFailed ,{
          // providerId: ,
          srcType: "Web/mWeb",
          // Date: Jan 19 2022 23:59:59,
          ErrorMessage: "You don't have access to Login",
          // userName_password_mismatch:true,
          srcPage: "Login",
          isSuccess: 0,
          failureReason: "Login failed",
        });

        switch (response.data.errorMessage) {
          case "Verify Email OTP":
            that.sendOtp()
            // showMessage : "OTP verification needed for Email.",
            toast.info("OTP verification needed for email.")
            that.setState({
              email: config.data.userName ,
              otpVerification:true,
              forcePasswordChange:true,
              tempAccessToken:response?.data?.authToken ?? response?.data?.accessToken,
            })
            break;

          case "verify OTP for device":
            that.sendOtp()
            // showMessage : "OTP verification needed for device.",
            toast.info("OTP verification needed for device.")
            that.setState({
              email: config.data.userName ,
              otpVerification:true,
              tempAccessToken:response?.data?.authToken ?? response?.data?.accessToken,
              blockPasswordChange:true,
            })
            break;
        
          default:
            // that.setState({
            //   showMessage :response && response.data && response.data.errorMessage  ? response.data.errorMessage.replaceAll("_"," ") : "You don't have access to Login."
            // })
            toast.error(`Authentification Failed: ${response && response.data && response.data.errorMessage  ? response.data.errorMessage.replaceAll("_"," ") : "You don't have access to Login"}`)
            break;
        }
      }
    }).catch(function (error) {
        toast.error("Unable to login")
        console.error(error);
      })
  }

  loginSetData = (response,that) =>{
    let roleName = null;
    auth.login(() => {
      roleName = that.checkRoleId(response.data.userDetails);
      response.data.userDetails.roleId = Roles[roleName]
      localStorage.setItem("access_token",JSON.stringify(response.data.accessToken));
      localStorage.setItem("user_details",JSON.stringify(response.data.userDetails));
      USER.user = response.data.userDetails;
      localStorage.setItem("roleName",roleName);
      that.props.history.push("/"+roleName+"/appointments");
      cleverTap(CLEVER_TAP_EVENTS.loginSuccess,{
        ProviderId: response.data.userDetails.providerId,
        platform: "web",
        Message: "Success",
        isSuccess: 1
      });
      window.clevertap.profile.push(response.data.userDetails);
    });
  }

carousel(){
  return(
    <Carousel
    autoPlay={true}
    interval={5000}
    showIndicators={true}
    showArrows={false}
    transitionTime={2000}
    infiniteLoop={true}
    autoFocus={false}
    showThumbs={false}
    stopOnHover={false}
    // renderIndicator
    showStatus={false}
    >
        {
            ["Reach a wider Customer-Base!", "Just some Other Text!","And another text!"].map( (item, i) => (
              <div key={i} className="flex h-24 justify-center w-full  text-2xl">
                <span>{item}</span>
              </div>
               
            ) )
        }
    </Carousel>
  )
}

  checkInsurer=()=>{
    return  ['ins-stage.medibuddy.in', 'ins.medibuddy.in'  ].includes(window.location.host)
  }

  forgotPass(data){
    if(!this.state.otp) {
      this.setState({passwordChangeErr:"Otp is required"}); 
      return
    }
    if(data.get("newPassword")!==data.get("confNewPassword")) {
      this.setState({passwordChangeErr:"New Password and Confirmed Passwords does not match"}); 
      return
    }
		let config = {
			url: this.url + "provider/forgotPassword",
			method: "post",
			data: {

        "authUserId": 0,
				"isAuthenticated": true,
				"applicationId": 10007,
				"emailId": this.state.email,
				"userName": this.state.email,
        "otpToVerify": this.state.otp,
				"newPassword" : data.get("newPassword"),
			}
		}
		axiosFinal(config)
		.then(res=>{
		  if(res.data.isSuccess){
        this.resetToLogin(()=>toast.success("Password Reset Successfull!"))
		  }
		  else{
        this.setState({
          resendOtp:null,
          passwordChangeErr: res && res.data && res.data.errorMessage ?  res.data.errorMessage: res?.data?.error ?? "Unable to Reset Password"
        })
		  }
		})
		.catch(err=>{
      this.setState({
        resendOtp:null,
        passwordChangeErr: err && err.data && err.data.errorMessage ?  err.data.errorMessage: err && err.data &&err.data.error?err.data.error : "Unable to Reset Password"
      })
		  })
  }

  render() {    
    if(localStorage.getItem('access_token')){
      this.props.history.push("/"+localStorage.getItem("roleName")+"/appointments");
    }
// login-back bg-no-repeat bg-cover bg-right
    return (
      <div className="flex justify-center space-x-0 md:space-x-0 ">
        <div className="invisible w-0 md:visible md:w-6/12 lg:w-8/12 block bg-left-top bg-cover amitabhBacchan relative">
          <div className='h-32 w-1/4 absolute inset-x-1/2 top-32 text-white md:inset-x-2/3 md:h-64'>
            {this.carousel()}
          </div>
         {/* {this.carouselBg()} */}
        </div>
        
        <div className="w-full md:w-6/12 lg:w-4/12 md:bg-white">
          <div className="flex flex-col h-screen overflow-y-scroll">
              {
                !this.state.otpVerification ?
            <div className="grid place-items-center my-10 lg:pl-10 sm:my-15 mr-14 my-auto">
                <div className="w-11/12 sm:w-11/12 p-10 md:w-6/12 lg:w-11/12 :w-4/12 
              px-6 py-10 sm:px-10 sm:py-6 
              bg-white rounded-lg shadow-md lg:shadow-none">
                  
                  <div className="flex">
                    <div className="w-15-per my-auto">
                      <img src={logo} alt="logo of provider"></img>
                    </div>
                    <div className="text-lg font-semibold pl-2">
                      <span className="text-mb-blue">Medi</span>
                      <span className="text-mb-red">Buddy</span>
                      <span className='border border-red-500 rounded-full px-0.5 -pt-2 text-mb-red' style={{fontSize:"6px"}}>R</span>
                      <br></br> 
                      {
                        !this.checkInsurer() ?
                        <React.Fragment>
                          <span className="text-mb-blue">Lab</span>
                          <span className="text-mb-blue">wise</span>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <span className="text-mb-red">Insur</span>
                          <span className="text-mb-blue">ance</span>
                        </React.Fragment>
                      }
                    </div>
                  </div>
          

                  <form className="mt-10" method="POST" onSubmit={(e) => this.handleSubmit(e)} style={{color: "#050a4e"}}>
                    <label htmlFor="email" className="block text-xs font-semibold uppercase">Email</label>
                    <input id="email" type="text" name="email" placeholder="email"
                      autoComplete="text"
                      onChange={(e) => this.checkCredentials(e)}
                      className="block w-full py-3 px-1 mt-2 
                      text-gray-800 appearance-none 
                      border-b-2 border-gray-100
                      focus:text-gray-500 focus:outline-none focus:border-gray-200 rounded-md"
                      required />
                    
                    <label htmlFor="password" className="block mt-2 text-xs font-semibold uppercase">Password</label>
                    <div className='flex py-3 px-1 mt-2 mb-4
                      text-gray-800 appearance-none 
                      border-b-2 border-gray-100
                       rounded-md'>
                    <input id="password" type={this.state.showPassword?"text":"password"} name="password" placeholder="password" autoComplete="current-password"
                      className="block w-full focus:text-gray-500  focus:border-gray-200 focus:outline-none"
                      required />
                      <span className='py-auto my-auto' onClick={()=> this.setState((state, props)=>({showPassword:!state.showPassword}))}>
                        {
                          this.state.showPassword?<VisibilityIcon/>:<VisibilityOffIcon/>
                        }
                      </span>
                    </div>

                    <button type="submit"
                      className={"w-full py-3 mt-2 bg-mb-btn-color font-medium text-white cursor-pointer focus:outline-none hover:bg-gray-700 hover:shadow-none rounded-md " + (this.state.showLoginDisabled ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                      disabled={this.state.showLoginDisabled} style={{backgroundColor:"rgb(23 120 242)"}}>
                      Sign In
                    </button>
                    {
                      !this.state.showForgotDialogBox && <div className="text-center pt-2">
                      <span className="text-mb-blue text-xs font-semibold cursor-pointer" onClick={()=>this.handleForgotPassDialogBox(true)}>Forgotten Password?</span>
                    </div>
                    }
                    
                    {
                    //   this.state.showForgotDialogBox &&  
                    //   <div className="head-tag-background-active rounded-md mt-2">
                    //   <div className="relative py-2 w-full" onClick={()=>this.handleForgotPassDialogBox(false)}>
                    //     <div className="absolute right-0.5 text-xs cursor-pointer text-gray-700">
                    //     <CloseIcon style={{fontSize: '18px'}}></CloseIcon>
                    //     </div>
                    //   </div>
                    
                    //     <div className="text-md font-semibold w-full px-2">
                    //       <div className="text-center">
                    //       {/* 9606583665 */}
                    //       8951902958
                    //       </div>
                    //     </div>
                    //     <div className="text-xs text-center px-2 pb-2">
                    //       Please call us, our executive will assist you in recovering your password
                    //     </div>    
                    // </div>
                    }
                  
                    <div className="text-center pt-5">
                        <p className="text-red-500 text-xs italic">{this.state.showMessage?.replaceAll("_"," ")}</p>
                    </div>
                  </form>
                </div>
                </div>
                :
                <div className="h-full p-8">
                  <span >
                    <ArrowBackOutlinedIcon className='font-bold' style={{color:"#1778f2"}} onClick={()=>this.setState({otpVerification:false, showForgotDialogBox:false, showMessage:null})}/>
                  </span>
                  <p className='font-semibold '>Enter OTP</p>
                  <p className='font-normal '>Please enter the OTP sent to <span className='font-semibold'>{this.state.email}</span></p>
                  <div className='my-3 flex w-48'>
                    <OtpInput
                      value={this.state.otp}
                      onChange={(e) => { this.setState({otp:e}) }}
                      numInputs={6}
                      isInputNum={true}
                      shouldAutoFocus={true}
                      hasErrored={this.state.otpErr}
                      errorStyle={{ color: "rgb(220 38 38)"}}
                      focusStyle={{ outline: 0, color: "rgb(2 132 199)", fontWeight:"bold"}}
                      inputStyle={this.state.otpErr?
                        { height:"100%", width:"1.5rem" , border:"0.5px solid rgb(115 115 115)",borderBottom:"0.5px solid rgb(220 38 38)", borderRadius:"5px", color:"rgb(220 38 38)"}
                      :{height:"100%", width:"1.5rem" , border:"0.5px solid rgb(115 115 115)", borderRadius:"5px", color: "rgb(37 99 235)", fontWeight:"bold"}}
                      separator={<span style={{minWidth:"10px"}}></span>}
                      containerStyle={{width:'100%'}}
									/>
                  </div>
                      <div className='pt-3 flex'>
                        <Button variant="contained" color="primary" size='small' className='mx-3' onClick={()=>this.sendOtp()}>Resend Otp</Button>
                        <span className='w-8'></span>
                  {
                    !this.state.showForgotDialogBox && ! this.state.forcePasswordChange &&
                        <Button variant="contained" color="primary" size='small' className='mx-3' onClick={()=>this.validateOtp()} disabled={!(this.state.otp && this.state.otp.length==6)}>Verify OTP</Button>
                      }
                      </div>
                  <div className="text-center  pt-5">
                            <p className={this.state.resendOtpErr?"text-red-500":"text-green-500"+" text-xs italic"}>{this.state.resendOtp}</p>
                            {
                              this.state.otpErr&&
                            <p className={"text-red-500 text-xs italic"}>{this.state.otpErr?.replaceAll("_"," ")}</p>
                            }
                  </div>
                  {
                    this.state.passwordChange && !this.state.blockPasswordChange && !this.state.forcePasswordChange &&
                    <div className="py-4">
                      <form className="mt-5" method="POST" onSubmit={(e) => this.handleSubmit(e)} style={{color: "#050a4e"}}>
                        <label htmlFor="oldPassword" className="block text-xs font-semibold ">Old Password</label>
                        <div className='flex py-3 px-1 mt-2 
                          text-gray-800 appearance-none 
                          border-b-2 border-gray-100'>
                        <input id="oldPassword" type={this.state.showOldPassword?"text":"password"} name="oldPassword" placeholder="Old Password"
                          autoComplete="text"
                          // onBlur={(e)=>this.passwordRegex(e,"oldPassword")}
                          onChange={(e)=> this.passwordRegex(e,"oldPassword")}
                          className="block w-full focus:text-gray-500 focus:outline-none focus:border-gray-200 rounded-md"
                          required />
                          <span className='py-auto my-auto' onClick={()=> this.setState((state, props)=>({showOldPassword:!state.showOldPassword}))}>
                          {
                            this.state.showOldPassword?<VisibilityIcon/>:<VisibilityOffIcon/>
                          }
                        </span>
                        </div>
                          <p className='text-red-300 text-sm'>{this.state.oldPassErr}</p>
                        
                        <label htmlFor="newPassword" className="block mt-2 text-xs font-semibold ">
                          New Password 
                          </label>
                          <div className='flex  py-3 px-1 mt-2 mb-4
                          text-gray-800 appearance-none 
                          border-b-2 border-gray-100'>
                        <input id="newPassword" type={this.state.showNewPassword?"text":"password"} name="newPassword" placeholder="New Password" autoComplete="current-password"
                        // onBlur={(e)=>this.passwordRegex(e,"newPassword")}
                        onChange={(e)=> this.passwordRegex(e,"newPassword")}
                          className="block w-full
                          focus:text-gray-500 focus:outline-none focus:border-gray-200 rounded-md"
                          required />
                        <span className='py-auto my-auto' onClick={()=> this.setState((state, props)=>({showNewPassword:!state.showNewPassword}))}>
                          {
                            this.state.showNewPassword?<VisibilityIcon/>:<VisibilityOffIcon/>
                          }
                        </span>
                          </div>
                          <p className='text-red-300 text-sm'>{this.state.newPassErr}</p>
                          
                        <label htmlFor="confNewPassword" className="block mt-2 text-xs font-semibold ">
                          Confirm Password 
                          </label>
                        <input id="confNewPassword" type={this.state.showConfNewPassword?"text":"password"} name="confNewPassword" placeholder="Confirm Password" autoComplete="current-password"
                        // onBlur={(e)=>this.passwordRegex(e,"confNewPassword")}
                        onChange={(e)=>  this.passwordRegex(e,"confNewPassword")}
                          className="block w-full py-3 px-1 mt-2 mb-4
                          text-gray-800 appearance-none 
                          border-b-2 border-gray-100
                          focus:text-gray-500 focus:outline-none focus:border-gray-200 rounded-md"
                          required />
                          <i className="bi bi-eye-slash" onClick={()=> this.setState((state, props)=>({showConfNewPassword:!state.showConfNewPassword}))}></i>
                          <p className='text-red-300 text-sm'>{this.state.confNewPassErr}</p>

                        <button type="submit"
                          className={"w-full py-3 mt-2 bg-mb-btn-color font-medium text-white cursor-pointer focus:outline-none hover:bg-gray-700 hover:shadow-none rounded-md " + (!this.state.allowPassChange ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                          disabled={!this.state.allowPassChange} style={{backgroundColor:"rgb(23 120 242)"}}>
                          Sign In
                        </button>
                      
                        <div className="text-center pt-5">
                            <p className="text-red-500 text-xs italic">{this.state.passwordChangeErr?.replaceAll('_'," ")}</p>
                        </div>
                      </form>
                    </div>
                  }
                  {
                    !this.state.passwordChange && ( this.state.showForgotDialogBox || this.state.forcePasswordChange ) &&
                    <div className="py-4">
                      <form className="mt-5" method="POST" onSubmit={(e) =>{this.handleSubmit(e)}} style={{color: "#050a4e"}}>
                        <label htmlFor="newPassword" className="block mt-2 text-xs font-semibold ">
                          New Password 
                          </label>
                          <div className='flex  py-3 px-1 mt-2 mb-4
                          text-gray-800 appearance-none 
                          border-b-2 border-gray-100'>
                        <input id="newPassword" type={this.state.showNewPassword?"text":"password"} name="newPassword" placeholder="New Password" autoComplete="current-password"
                        // onBlur={(e)=>this.passwordRegex(e,"newPassword")}
                        onChange={(e)=>this.passwordRegex(e,"newPassword")}
                        // onChange={(e)=>this.state.newPassErr && this.passwordRegex(e,"newPassword")}
                          className="block w-full
                          focus:text-gray-500 focus:outline-none focus:border-gray-200 rounded-md"
                          required />
                        <span className='py-auto my-auto' onClick={()=> this.setState((state, props)=>({showNewPassword:!state.showNewPassword}))}>
                          {
                            this.state.showNewPassword?<VisibilityIcon/>:<VisibilityOffIcon/>
                          }
                        </span>
                          </div>
                          <p className='text-red-300 text-sm'>{this.state.newPassErr}</p>
                          
                        <label htmlFor="confNewPassword" className="block mt-2 text-xs font-semibold ">
                          Confirm Password 
                          </label>
                        <input id="confNewPassword" type={this.state.showConfNewPassword?"text":"password"} name="confNewPassword" placeholder="Confirm Password" autoComplete="current-password"
                        // onBlur={(e)=>this.passwordRegex(e,"confNewPassword")}
                        onChange={(e)=>this.passwordRegex(e,"confNewPassword")}
                        // onChange={(e)=> this.state.confNewPassErr && this.passwordRegex(e,"confNewPassword")}
                          className="block w-full py-3 px-1 mt-2 mb-4
                          text-gray-800 appearance-none 
                          border-b-2 border-gray-100
                          focus:text-gray-500 focus:outline-none focus:border-gray-200 rounded-md"
                          required />
                          <i className="bi bi-eye-slash" onClick={()=> this.setState((state, props)=>({showConfNewPassword:!state.showConfNewPassword}))}></i>
                          <p className='text-red-300 text-sm'>{this.state.confNewPassErr}</p>

                        <button type="submit"
                          className={"w-full py-3 mt-2 bg-mb-btn-color font-medium text-white cursor-pointer focus:outline-none hover:bg-gray-700 hover:shadow-none rounded-md " + (!(this.state.allowPassChange && this.state.otp && this.state.otp.length === 6) ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                          disabled={!(this.state.allowPassChange && this.state.otp && this.state.otp.length === 6)} style={{backgroundColor:"rgb(23 120 242)"}}>
                          Sign In
                        </button>
                      
                        <div className="text-center pt-5">
                            <p className="text-red-500 text-xs italic">{this.state.passwordChangeErr?.replaceAll("_"," ")}</p>
                        </div>
                      </form>
                    </div>
                  }
                </div>
              }
          </div>
        </div>

      </div>
    );
  }
}

export default SignUp;
